import React from "react"
import CustomFormGroup from "./CustomFormGroup"
import { TextArea } from "@blueprintjs/core"
import { withFormController } from "../Molecules/FormController"
const CustomTextArea = ({
  label,
  helperText,
  inline,
  error,
  labelInfo,
  path,
  onChange,
  onAdd,
  onRemove,
  big,
  className,
  ...otherProps
}) => {
  const handleChange = ({ target }) => {
    onChange && onChange(path, target.value)
  }
  return (
    <CustomFormGroup
      className={className}
      label={label}
      helperText={helperText}
      inline={inline}
      error={error}
      labelInfo={labelInfo}
      big={big}
    >
      <TextArea
        intent={error ? "danger" : "none"}
        onChange={handleChange}
        {...otherProps}
      />
    </CustomFormGroup>
  )
}

export default withFormController(CustomTextArea)
